import store from '@/store'
import {
  DATE_FORMAT,
  DATE_TIME_FORMAT,
  TIME_FORMAT,
  formatDateInTimeZone,
} from '@/@core/utils/dateWithTimezone'

const whitelabelTimeZone = () =>
  store.getters['whitelabelCurrencyNabvar/WHITELABEL_TIMEZONE'] || null

export const formatWlDateTime = (value) =>
  formatDateInTimeZone(value, whitelabelTimeZone(), DATE_TIME_FORMAT)

export const formatWlDate = (value) =>
  formatDateInTimeZone(value, whitelabelTimeZone(), DATE_FORMAT)

export const formatWlTime = (value) =>
  formatDateInTimeZone(value, whitelabelTimeZone(), TIME_FORMAT)

export const formatWlWallTime = (value) =>
  formatDateInTimeZone(value, whitelabelTimeZone(), DATE_TIME_FORMAT, { naive: 'wall' })
